import { forwardRef, type ReactNode, type SelectHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  invalid?: boolean;
  placeholder?: string;
  children?: ReactNode;
}

/**
 * Select nativo com o visual do Figma (Text field + icon/chevron-down-16px).
 * Nativo por acessibilidade e teclado; a seta é sobreposta via CSS (appearance: none).
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, invalid, placeholder, value, children, ...props },
  ref,
) {
  return (
    <div className="relative">
      <select
        ref={ref}
        value={value}
        aria-invalid={invalid || undefined}
        className={cn(
          'h-10 w-full cursor-pointer appearance-none rounded-xl border border-line bg-surface px-2 pr-8 text-base text-ink',
          'focus:border-brand-outline focus:outline-none focus:ring-2 focus:ring-brand-100',
          'disabled:cursor-not-allowed disabled:bg-surface-muted',
          !value && 'text-placeholder',
          className,
          invalid && 'border-flag-danger focus:border-flag-danger focus:ring-red-100',
        )}
        {...props}
      >
        {placeholder !== undefined && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {children}
      </select>
      <img
        src="/icons/chevron-down-16.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute right-2 top-1/2 size-4 -translate-y-1/2"
      />
    </div>
  );
});
